import React from 'react'
import { BodyText, Button } from '@paypalcorp/pp-react'
import styles from './AiSearch.module.css'

const FeedbackRating = ({
  answerId,
  searchID,
  selectedRating,
  setSelectedRating,
}: {
  answerId: string
  searchID: string
  selectedRating: number
  setSelectedRating: React.Dispatch<React.SetStateAction<number>>
}) => {
  const fptiData = typeof window !== `undefined` && window.fpti
  const RATINGS = [1, 2, 3, 4, 5]

  const fbRatingHandler = (rating: number) => {
    setSelectedRating(rating)

    if (fptiData) {
      const options = {
        data: {
          page: fptiData.page,
          pgrp: fptiData.pgrp,
          e: 'cl',
          tag: `was this helpful-${rating}`,
          link: `gen-ai-summary|feedback|was this helpful-${rating}|${answerId}`,
          component: 'devdiscoverynodeweb',
          searchID,
        },
      }

      if (window.PAYPAL?.analytics?.instance) {
        window.PAYPAL?.analytics?.instance?.record(options)
      }
    }
  }

  return (
    <div className={`${styles.feedbackRating__container} ${styles.vertical}`}>
      <BodyText className={`${styles.text_sm}`}>
        Please rate your experience with this tool based on how useful it is
      </BodyText>

      <div className={`${styles.feedbackRating__buttons}`}>
        {RATINGS.map((num) => (
          <Button
            key={num}
            secondary={selectedRating !== num}
            primary={selectedRating === num}
            className={`${styles.feedbackRating__button} ${styles.text_sm}`}
            size="sm"
            onClick={() => fbRatingHandler(num)}
          >
            {num}
          </Button>
        ))}
      </div>
    </div>
  )
}

export default FeedbackRating
